import React from "react";
import Header from "../pages/header"; // Adjust path as needed
import Footer from "../pages/footer"; // Adjust path as needed

// Placeholder images - Replace with your actual imports
import blog_hero from "../../img/about_1.jpg";
import author_img from "../../img/testimonial_1.jpg";

const ResumeGuide = () => {
  return (
    <>
      <Header />

      {/* --- 1. PAGE HEADER --- */}
      <div className="container-fluid py-5 bg-dark page-header mb-5">
        <div className="container my-5 pt-5 pb-4">
          <h1 className="display-3 text-white mb-3 animated slideInDown">How to Write a Perfect Resume?</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb text-uppercase">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item"><a href="#Career Tips">Career Tips</a></li>
              <li className="breadcrumb-item"><a href="#Resume Guide">Resume Guide</a></li>
            </ol>
          </nav>
        </div>
      </div>

      {/* --- 2. ARTICLE CONTENT --- */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5">
            {/* Left Column: Main Article */}
            <div className="col-lg-8">
              {/* Meta Data */}
              <div className="d-flex align-items-center mb-4">
                <img
                  src={author_img}
                  alt="Author"
                  className="rounded-circle me-3"
                  style={{ width: "50px", height: "50px", objectFit: "cover" }}
                />
                <div>
                  <h6 className="mb-0 text-dark">Written by John Doe</h6>
                  <small className="text-muted">
                    Updated: Dec 18, 2025 • 5 min read
                  </small>
                </div>
              </div>

              {/* Featured Image */}
              <div className="mb-5">
                <img
                  className="img-fluid rounded w-100 shadow-sm"
                  src={blog_hero}
                  alt="Resume Writing Guide"
                  style={{ maxHeight: "400px", objectFit: "cover" }}
                />
              </div>

              {/* Article Body */}
              <article className="article-body">
                <p className="lead mb-4">
                  A well-crafted resume is your ticket to a job interview. In
                  today's competitive market, recruiters spend an average of{" "}
                  <strong>7 seconds</strong> scanning a resume. Learn the key
                  strategies to make your CV stand out and pass the ATS bots.
                </p>

                <h2 className="mb-3 mt-5">1. Choose the Right Format</h2>
                <p>
                  Before you start writing, you need to decide on the structure.
                  The most common formats are:
                </p>
                <ul className="list-unstyled mb-4">
                  <li className="mb-2">
                    <i className="fa fa-check text-primary me-2"></i>
                    <strong>Chronological:</strong> Best for those with a steady
                    work history.
                  </li>
                  <li className="mb-2">
                    <i className="fa fa-check text-primary me-2"></i>
                    <strong>Functional:</strong> Focuses on skills rather than
                    history (good for career changers).
                  </li>
                  <li className="mb-2">
                    <i className="fa fa-check text-primary me-2"></i>
                    <strong>Hybrid:</strong> A mix of both, highlighting skills
                    first, followed by history.
                  </li>
                </ul>

                <h2 className="mb-3 mt-5">
                  2. Beat the ATS (Applicant Tracking System)
                </h2>
                <p>
                  75% of resumes are rejected by automated systems before a
                  human ever sees them. To ensure yours gets through:
                </p>
                <div className="bg-light p-4 rounded border-start border-5 border-primary mb-4">
                  <h5 className="mb-2">ATS Checklist:</h5>
                  <ul className="mb-0">
                    <li>
                      Use standard headings (Experience, Education, Skills).
                    </li>
                    <li>
                      Avoid graphics, columns, and tables (they confuse the
                      bots).
                    </li>
                    <li>Include keywords found in the job description.</li>
                    <li>
                      Save your file as a <strong>.DOCX</strong> or{" "}
                      <strong>.PDF</strong>.
                    </li>
                  </ul>
                </div>

                <h2 className="mb-3 mt-5">3. Use Power Words & Numbers</h2>
                <p>
                  Don't just list your duties. List your <em>achievements</em>.
                  Use quantifiable data to prove your worth.
                </p>
                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <div className="p-3 border rounded bg-white shadow-sm text-danger">
                      <i className="fa fa-times-circle me-2"></i>{" "}
                      <strong>Bad Example:</strong>
                      <br />
                      "Managed a sales team and increased revenue."
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-3 border rounded bg-white shadow-sm text-success">
                      <i className="fa fa-check-circle me-2"></i>{" "}
                      <strong>Good Example:</strong>
                      <br />
                      "Led a team of 10 sales reps to achieve{" "}
                      <strong>$2M</strong> in revenue, a{" "}
                      <strong>20% increase</strong> YoY."
                    </div>
                  </div>
                </div>

                <h2 className="mb-3 mt-5">4. Tailor It Every Time</h2>
                <p>
                  Sending the same generic resume to 50 jobs is a recipe for
                  failure. Take 5 minutes to tweak your "Summary" and "Skills"
                  section to match the specific role you are applying for.
                </p>

                <hr className="my-5" />

                <h4 className="mb-3">Ready to apply?</h4>
                <p>
                  Now that your resume is perfect, browse our latest listings.
                </p>
                <a href="/jobs" className="btn btn-primary py-3 px-5">
                  Find a Job Now
                </a>
              </article>

              {/* Comments / Interaction Section */}
              <div className="mt-5 pt-4 border-top">
                <h4 className="mb-4">Comments (0)</h4>
                <div className="bg-light p-4 rounded">
                  <p className="text-muted text-center mb-0">
                    You must be logged in to post a comment.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Sidebar */}
            <div className="col-lg-4">
              {/* Search Widget */}
              <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control p-3"
                    placeholder="Keyword"
                  />
                  <button className="btn btn-primary px-4">
                    <i className="bi bi-search"></i>
                  </button>
                </div>
              </div>

              {/* Category Widget */}
              <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <h4 className="mb-4">Categories</h4>
                <div className="d-flex flex-column justify-content-start">
                  {[
                    "Web Design",
                    "Marketing",
                    "Customer Support",
                    "Data Science",
                    "HR",
                  ].map((cat, i) => (
                    <a
                      className="h6 fw-normal bg-light rounded py-2 px-3 mb-2 d-flex justify-content-between"
                      href="#"
                      key={i}
                    >
                      <span>
                        <i className="bi bi-chevron-right me-2"></i>
                        {cat}
                      </span>
                      <span>({Math.floor(Math.random() * 50) + 10})</span>
                    </a>
                  ))}
                </div>
              </div>

              {/* Related Jobs Widget (Crucial for conversion) */}
              <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <h4 className="mb-4">Related Jobs</h4>
                {[
                  {
                    title: "Senior Content Writer",
                    loc: "Remote",
                    salary: "$50k - $70k",
                  },
                  {
                    title: "HR Specialist",
                    loc: "New York, USA",
                    salary: "$60k - $80k",
                  },
                  {
                    title: "Resume Reviewer",
                    loc: "London, UK",
                    salary: "$40k - $50k",
                  },
                ].map((job, i) => (
                  <div
                    className="d-flex align-items-center mb-3 bg-white p-3 rounded shadow-sm border"
                    key={i}
                  >
                    <div
                      className="bg-primary d-flex align-items-center justify-content-center rounded text-white"
                      style={{ width: "45px", height: "45px" }}
                    >
                      <i className="fa fa-briefcase"></i>
                    </div>
                    <div className="ps-3">
                      <h6 className="mb-1">{job.title}</h6>
                      <small className="text-muted d-block">{job.loc}</small>
                      <small className="text-primary fw-bold">
                        {job.salary}
                      </small>
                    </div>
                  </div>
                ))}
                <a href="/jobs" className="btn btn-primary w-100 py-2">
                  View All Jobs
                </a>
              </div>

              {/* Tags Widget */}
              <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <h4 className="mb-4">Tags</h4>
                <div className="d-flex flex-wrap m-n1">
                  {[
                    "Resume",
                    "Interview",
                    "Career",
                    "Skills",
                    "Growth",
                    "Salary",
                  ].map((tag, i) => (
                    <a href="" className="btn btn-light m-1" key={i}>
                      {tag}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ResumeGuide;
